<template>
  <div id="about" class="about mdc-layout-grid mdc-container pt-5 mt-5">
    <section
      class="col-md-7 order-md-1 text-center text-md-left pr-md-5"
      style="height:80vh;"
    >
      <h2
        data-aos="fade-in"
        data-aos-easing="linear"
        data-aos-delay="500"
        data-aos-duration="2000"
        class="mdc-typography--headline3 font-weight-bold"
      >
        <vue-typed-js
          :strings="[
            $t('word1'),
            $t('word2'),
            $t('word3'),
            $t('word4'),
            $t('word5')
          ]"
          :typeSpeed="80"
          :startDelay="2000"
          :showCursor="false"
          :cursorChar="'_'"
          ><h3 class="mdc-typography--headline3 font-weight-bold">
            At Surfverse <span class="typing"></span>
          </h3>
        </vue-typed-js>
      </h2>
      <p
        data-aos="fade-in"
        data-aos-easing="linear"
        data-aos-delay="2500"
        data-aos-duration="2000"
        class="mdc-typography--headline5"
      >
        We're just getting started.
      </p>
    </section>
    <section class="p-5 mb-5 text-center">
      <div class="container">
        <h2
          :data-text="$t('about')"
          data-aos="zoom-out-up"
          data-aos-delay="300"
          data-aos-duration="500"
          class="mdc-typography--headline2 font-weight-bold engineering-h2 engineering-subtitle glitch-animation anim-repeat anim-delay"
        >
          {{ $t('about') }}
        </h2>
        <p
          class="mdc-typography--headline6 font-weight-bold engineering-p mb-0 text-oswald"
        >
          {{ $t('mission') }}
        </p>
        <p class="mdc-typography--body2 engineering-p mb-0 text-oswald">
          {{ $t('workhard') }}
        </p>
      </div>
    </section>

    <div class="mdc-layout-grid__inner">
      <div
        class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-1-phone"
      >
        <div id="desc">
          <h6 class="mdc-typography--headline6 text-nav text-color text-center">
            {{ $t('vision') }}
          </h6>
          <p class="mdc-typography--subtitle2 text-center">
            {{ $t('vision-desc') }}
          </p>
        </div>
      </div>
      <div
        class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone"
      >
        <div id="desc">
          <h6 class="mdc-typography--headline6 text-nav text-color text-center">
            {{ $t('ourmission') }}
          </h6>
          <p class="mdc-typography--subtitle2 text-center">
            {{ $t('mission-desc') }}
          </p>
        </div>
      </div>
      <div
        class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-1-phone"
      >
        <div id="desc">
          <h6 class="mdc-typography--headline6 text-nav text-color text-center">
            {{ $t('commit-date') }}
          </h6>
          <p class="mdc-typography--subtitle2 text-center">
            {{ $t('commit') }}
          </p>
        </div>
      </div>
    </div>
    <p class="mdc-typography--headline6 mt-5 pt-5">
      {{ $t('about-company') }}
    </p>
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell">
        <div class="mdc-layout-grid__inner h-100">
          <div
            class="mdc-layout-grid__cell feature-cell mdc-layout-grid__cell--span-12-desktop"
          >
            <figure
              class="front-panel-bgimage image-about-city progressive-image-animated"
              data-progressive-image-loaded
            ></figure>
          </div>
          <div
            class="mdc-layout-grid__cell feature-cell mdc-layout-grid__cell--span-12-desktop"
          >
            <figure
              class="front-panel-bgimage image-about-city2 progressive-image-animated"
              data-progressive-image-loaded
            ></figure>
          </div>
        </div>
      </div>
      <div
        class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        style="min-height: 480px; height:480px;"
      >
        <figure
          class="front-panel-bgimage image-about-me progressive-image-animated"
          data-progressive-image-loaded
        ></figure>
      </div>
      <div
        class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-5-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        style="min-height: 480px; height:480px;"
      >
        <figure
          class="front-panel-bgimage image-about-us progressive-image-animated"
          data-progressive-image-loaded
        ></figure>
      </div>
    </div>
    <!-- <div class="banner">
      <img
        src="/img/about/sv-art-logo.png"
        class="img-fluid"
        alt="Company banner"
      />
    </div> -->
  </div>
</template>

<i18n>
{
  "en": {
    "surfverse": "SURFVERSE",
    "about-company": "Founded in 2021 by Bogdan Mateescu, our mission is to empower every startup. By resolving complexity we enable founders to be more productive. By simplifying collaboration we make it easier for teams and investors to work on what matters together.",
    "about": "About Us",
    "workhard": "We’re working hard to build a supportive, welcoming community for founders and Investors alike.",
    "ourmission": "Mission",
    "mission": "We’re on a mission to build the world’s best community for founders and their startups.",
    "mission-desc": "Supporting future entrepreneurs to shape our world.",
    "vision": "Vision",
    "vision-desc": "Simplicity",
    "footer-question": "Founders all over the world work on new products, experiences, and services every day. Come with us.🤙",
    "commit-date": "August 2017",
    "commit": "First commit",
    "word1": "we make problems",
    "word2": "i mean ^1000 we fix bugs",
    "word3": "sometimes ^1000 we solve problems",
    "word4": "i mean",
    "word5": "we make software, ok?"
  },
  "ro": {
    "surfverse": "SURFVERSE",
    "about-company": "Fondată în 2021 de Bogdan Mateescu, misiunea noastră este de a sprijinii fiecare startup. Rezolvând complexitatea, permitem fondatorilor să fie mai productivi. Simplificând colaborarea, facilităm echipele și investitorii să lucreze la ceea ce contează, împreună.",
    "about": "Despre Noi",
    "workhard": "Lucrăm din greu pentru a construi o comunitate de sprijin și primitoare atât pentru fondatori, cât și pentru investitori.",
    "ourmission": "Misiune",
    "mission": "Suntem într-o misiune de a construi cea mai prietenoasă comunitate din lume pentru fondatori și startup-urile acestora.",
    "mission-desc": "Sprijinirea viitorilor antreprenori în călătoria lor de a remodela lumea.",
    "vision": "Viziune",
    "vision-desc": "Simplitatea",
    "footer-question": "Founders all over the world work on new products, experiences, and services every day. Come with us.🤙",
    "commit-date": "August 2017",
    "commit": "Primul commit"
  },
  "de": {
    "surfverse": "SURFVERSE",
    "about-company": "Founded in 2021 by Bogdan Mateescu, our mission is to empower every startup. By resolving complexity we enable founders to be more productive. By simplifying collaboration we make it easier for teams and investors to work on what matters together.",
    "about": "About Us",
    "ourmission": "Mission",
    "mission": "Willkommen bei Surfverse, Startups Secret Launcher.",
    "vision": "Vision",
    "footer-question": "Gründer auf der ganzen Welt arbeiten jeden Tag an neuen Produkten, Erfahrungen und Dienstleistungen. Komm mit uns.🤙",
    "commit-date": "August 2017",
    "commit": "First commit"
  }
}
</i18n>

<style>
div#app.router-about {
  background-image: url(/img/about/coffe.jpg);
  background-position: center;
  background-size: cover;
}
.image-about-us {
  width: 100%;
  height: 100%;
  background-size: auto;
  background-repeat: no-repeat;
  background-image: url(/img/about/sv-art-logo.png);
  background-position: center;
  background-size: cover;
}
.image-about-me {
  width: 100%;
  height: 100%;
  background-size: auto;
  background-repeat: no-repeat;
  background-image: url(/img/about/mateesville-full.jpg);
  background-position: center;
  background-size: cover;
}
.image-about-city {
  width: 100%;
  height: 100%;
  background-size: auto;
  background-repeat: no-repeat;
  background-image: url(/img/maps/medgidia.jpg);
  background-position: center;
  background-size: cover;
}
.image-about-city2 {
  width: 100%;
  height: 100%;
  background-size: auto;
  background-repeat: no-repeat;
  background-image: url(/img/maps/constanta.jpg);
  background-position: center;
  background-size: cover;
}
.jumbotron {
  background-color: var(--grid-cell);
}
.banner {
  height: 100%;
  width: 100%;
}
</style>

<script>
export default {
  name: 'About',
  // metaInfo: {
  //   // if no subcomponents specify a metaInfo.title, this title will be used
  //   title: 'About',
  //   // all titles will be injected into this template
  //   titleTemplate: '%s | My Awesome Webapp',
  //   meta: [{ name: 'description', content: '' }]
  // },
  metaInfo() {
    return {
      title: this.$t('title') || 'Default',
      titleTemplate: '%s | Surfverse',
      meta: [{ name: 'description', content: this.$t('description') }]
    }
  }
}
</script>
<i18n>
{
  "en": {
    "title": "About Us",
    "description": "Connect with friends, family and other people you know. Share photos and videos, send messages and get updates.",
    "mission": "Supporting future",
    "vision": "",
    "scope": ""
  },
  "ro": {
    "title": "Despre noi",
    "description": "Gaseste prieteni, fondatori si vezi ce e nou in lumea startup-urilor",
    "mission": "Sprijinim viitorii antreprenori în călătoria lor de a remodela lumea."
  },
  "de": {
    "title": "About Us",
    "description": "Deutch in germana",
    "mission": "Sprijinim viitorii antreprenori în călătoria lor de a remodela lumea."
  }
}
</i18n>
